// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"41d5826c","156":"e88c4021","236":"d7f3b369","460":"e66ab630","593":"d25919d0","718":"1bd221b3","735":"3af132ef","871":"c9f4bb5d"}[chunkId] + ".chunk.css";
};